import React, { useEffect, useState } from 'react';
import { useTranslations } from '../../localization/useTranslations';

interface UserCardProps {
  updateSnackbarMessage: (message: string) => void;
}

const UserCard: React.FC<UserCardProps> = ({ updateSnackbarMessage }) => {
  const [userData, setUserData] = useState({
    name: '',
    email: '',
    avatarUrl: '',
  });
  const translations = useTranslations();

  useEffect(() => {
    const setData = async () => {
      try {
        const avatarUrl: string = window.crm_user?.user_meta?.avatar_url || window.defaultUserAvatar;

        const userFirstName = window?.crm_user?.user?.first_name || '';
        const userLastName = window?.crm_user?.user?.last_name || '';
        const userEmail = window?.crm_user?.user?.email || '';

        setUserData({
          name: `${userFirstName} ${userLastName}`,
          email: userEmail,
          avatarUrl: avatarUrl,
        });
      } catch (error) {
        updateSnackbarMessage(translations?.snackBarMessages?.somethingWentWrong || 'Error fetching user data');
      }
    };

    setData();
  }, [translations?.snackBarMessages?.somethingWentWrong, updateSnackbarMessage]);

  const hasName = userData.name.trim().length > 0;
  const primary = hasName ? userData.name : userData.email;
  const secondary = hasName ? userData.email : '';

  return (
    <div className="user-card">
      <div className="user-card__avatar">
        <img src={userData.avatarUrl} alt="User Avatar" />
      </div>

      <div className="user-card__details">
        <div className="user-card__name">{primary}</div>
        <div className="user-card__email">{secondary}</div>
      </div>
    </div>
  );
};

export default UserCard;
